// extracted by mini-css-extract-plugin
module.exports = {"accordion":"accordion_accordion__2T1zJ"};